import styled from '@emotion/styled'

export const SalarySummaryWrapper = styled.header``
